import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQs: React.FC = () => {
  const [expanded, setExpanded] = useState<number | false>(false);

  const handleChange =
    (panel: number) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            q: "How will I receive the joining link?",
            a: "Once you register, you will receive a confirmation email with the live session link and event details. Please ensure you enter the correct email ID during registration.",
        },
        {
            q: "Is this a motivationaIs this a LIVE webinar?",
            a: "Yes. This is a live 2-hour masterclass with real-time teaching and Q&A.",
        },
        {
            q: "Will I get a recording?",
            a: "The focus is on live participation. Recording access is not guaranteed, so we recommend attending the session live.",
        },
        {
            q: "Who is this masterclass ideal for?",
            a: "Business owners, sales leaders, founders, and professionals handling high-value sales conversations who want more predictable revenue.",
        },
        {
            q: "Is this applicable to my industry?",
            a: "Yes. The frameworks discussed apply to both product and service businesses, especially those dealing with high-ticket or consultative sales.",
        },
        {
            q: "I’m not in real estate. Is this still relevant?",
            a: "Absolutely. This session focuses on sales psychology, structure, and buyer behaviour, applicable across industries.",
        },
        {
            q: "Can I attend with my business partner or sales head?",
            a: "Yes, you may register multiple participants separately to ensure each receives access details.",
        },
        {
            q: "What do I need to keep ready during the session?",
            a: "A notebook, your current sales challenges in mind, and clarity about where your team is struggling.",
        },
        {
            q: "What if I miss the session?",
            a: "As this is a live interactive session, we strongly recommend attending. Replays may not be available.",
        },
        {
            q: "Is this really free?",
            a: "Yes, There is no cost to attend this live masterclass.",
        },

    ];

  return (
    <Box sx={{ background: "#000", py: 12 }}>
      <Container maxWidth="md">

        {/* TITLE */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            mb: 8,
            fontWeight: 700,
            background:
              "linear-gradient(90deg,#ffffff 0%,#d4af37 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Frequently Asked Questions
        </Typography>

        {faqs.map((faq, i) => (
          <Accordion
            key={i}
            expanded={expanded === i}
            onChange={handleChange(i)}
            sx={{
              background: "#0a0a0a",
              color: "#fff",
              mb: 3,
              borderRadius: "14px !important",
              border: "1px solid rgba(212,175,55,0.35)",
              overflow: "hidden",
              transition: "0.3s",

              "&:hover": {
                border: "1px solid #d4af37",
                boxShadow: "0 10px 40px rgba(212,175,55,0.15)",
              },

              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon sx={{ color: "#d4af37" }} />
              }
              sx={{
                px: 3,
                py: 1,
              }}
            >
              {/* NUMBER */}
              <Typography
                sx={{
                  fontWeight: 700,
                  color: "#d4af37",
                  mr: 2,
                  fontSize: "20px",
                  minWidth: 35,
                }}
              >
                {String(i + 1).padStart(2, "0")}
              </Typography>

              {/* QUESTION */}
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color:'white'
                }}
              >
                {faq.q}
              </Typography>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                borderTop: "1px solid rgba(212,175,55,0.2)",
                px: 5,
                pb: 3,
              }}
            >
              <Typography
                sx={{
                  color: "#cfd8dc",
                  lineHeight: 1.8,
                  fontSize: "15px",
                  textAlign:'start'
                }}
              >
                {faq.a}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
};

export default FAQs;